import { Routes } from '@angular/router';
 import { HubComponent } from './core/components/hub/hub.component';
import { AppLayoutComponent } from './core/components/layout/app-layout.component';
 import { AutoLoginComponent } from './core/components/login/autologin.component';
import { LoginComponent } from './core/components/login/login.component';
import { MentionsLegalesComponent } from './core/components/mentions-legales/mentions-legales.component';
 import { AuthGuardService } from './core/guards/auth-guard.service';
 import { TokenGS1Guard } from './core/guards/tokenGS1.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { TokenAdminGuard } from './token-admin.guard';

const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            { path: '', redirectTo: '/autologin', pathMatch: 'full'},
              
            { path: 'unauthorized', component: UnauthorizedComponent },
            { path: 'accueil', canActivate: [AuthGuardService, TokenGS1Guard,TokenAdminGuard], loadChildren: () => import('./hub/hub.module').then(m => m.HomeModule)},

            { path: 'mentions-legales', component: MentionsLegalesComponent},
            { path: 'bannières-marketing', canActivate: [AuthGuardService, TokenGS1Guard,TokenAdminGuard], data: { expectedRole: ['administrateur'] }, loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
            { path: 'maintenance', canActivate: [AuthGuardService, TokenGS1Guard,TokenAdminGuard], data: { expectedRole: ['administrateur'] }, loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule)},

        ]
    },
    
    { path: 'signin-oidc', component: LoginComponent },
    { path: 'autologin', component: AutoLoginComponent },
 
     { path: '**', redirectTo: 'autologin' }
]

export const routing = routes;
